import React from 'react'
import { ArrowDownIcon } from 'lucide-react'
export function FilterBar({
    activeFilter,
    setActiveFilter,
    sortBy,
    setSortBy,
}) {
    const filters = [
        {
            id: 'all',
            label: 'All Jobs',
        },
        {
            id: 'saved',
            label: 'Saved',
        },
    ]
    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
            <div className="flex overflow-x-auto pb-2 md:pb-0 hide-scrollbar">
                {filters.map((filter) => (
                    <button
                        key={filter.id}
                        className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full mr-2 ${activeFilter === filter.id ? 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`}
                        onClick={() => setActiveFilter(filter.id)}
                    >
                        {filter.label}
                    </button>
                ))}
            </div>
            <div className="flex items-center space-x-2">
                <div className="relative">
                    <select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="appearance-none pl-3 pr-8 py-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-600 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="match">Match Score</option>
                        <option value="recent">Most Recent</option>
                        <option value="salary">Salary: High to Low</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500 dark:text-gray-400">
                        <ArrowDownIcon size={16} />
                    </div>
                </div>
            </div>
        </div>
    )
}
